module.exports = __webpack_public_path__ + "static/media/collection-active.c519ff37.svg";